export default __webpack_public_path__ + "static/media/bxl-wordpress.f4f7705e.svg";